import React from 'react';
import classNames from 'classnames';
import { goddessMecha as p } from '../../data/products';

const Stars = ({ score }) => (
  <span className="stars" aria-label={`${score} out of 5`}>
    {[1, 2, 3, 4, 5].map(i => (
      <svg key={i} width="14" height="14" viewBox="0 0 24 24" className={classNames('star', i <= Math.round(score) && 'is-filled')} aria-hidden="true">
        <path d="M12 2.5l2.9 6.1 6.7.8-4.9 4.6 1.3 6.6L12 17.3l-6 3.3 1.3-6.6L2.4 9.4l6.7-.8z" />
      </svg>
    ))}
  </span>
);

const ProductGoddessMecha = ({ className, ...props }) => {

  const outerClasses = classNames('section product product-gm', className);

  return (
    <section {...props} id={p.id} className={outerClasses}>
      <div className="product-backdrop" style={{ backgroundImage: 'url(/img/gm/banner.jpg)' }} aria-hidden="true" />
      <div className="container">
        <div className="section-inner">

          <div className="product-head reveal-from-bottom">
            <img className="product-logo" src="/img/gm/title.png" alt={p.name} width={240} height={94} />
            <div className="product-head-text">
              <p className="product-kicker text-xxs m-0">{p.nameJa} · {p.platform}</p>
              <h2 className="product-tagline mt-8 mb-0">{p.tagline}</h2>
            </div>
          </div>

          <div className="product-main">
            <div className="product-media reveal-from-left" data-reveal-delay="100">
              <div className="responsive-video">
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${p.youtubeId}?rel=0&modestbranding=1`}
                  title={p.youtubeTitle}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>

            <div className="product-copy reveal-from-right" data-reveal-delay="200">
              <p className="product-desc m-0">{p.description}</p>

              <div className="product-ratings">
                <div className="rating-badge">
                  <span className="rating-score">{p.ratings.googlePlay.score.toFixed(1)}</span>
                  <span className="rating-detail">
                    <Stars score={p.ratings.googlePlay.score} />
                    <span className="text-xxs">Google Play · {p.ratings.googlePlay.count.toLocaleString()} ratings · {p.ratings.googlePlay.installs} downloads</span>
                  </span>
                </div>
                <div className="rating-badge">
                  <span className="rating-score">{p.ratings.appStore.score.toFixed(1)}</span>
                  <span className="rating-detail">
                    <Stars score={p.ratings.appStore.score} />
                    <span className="text-xxs">App Store</span>
                  </span>
                </div>
              </div>

              <div className="store-badges">
                <a href={p.googlePlay} target="_blank" rel="noopener noreferrer">
                  <img src="/google_play.png" alt="Get it on Google Play" height={48} />
                </a>
                <a href={p.appStore} target="_blank" rel="noopener noreferrer">
                  <img src="/app_store.png" alt="Download on the App Store" height={48} />
                </a>
              </div>
              <p className="text-xxs product-footnote m-0">Store ratings as of {p.ratings.asOf}.</p>
            </div>
          </div>

          <ul className="product-features list-reset">
            {p.features.map((f, i) => (
              <li key={f.title} className="product-feature reveal-from-bottom" data-reveal-delay={100 * i}>
                <span className="product-feature-index text-xxs">0{i + 1}</span>
                <h4 className="mt-0 mb-8">{f.title}</h4>
                <p className="m-0 text-sm">{f.body}</p>
              </li>
            ))}
          </ul>

          <div className="product-gallery">
            {p.screenshots.map((s, i) => (
              <figure key={s.src} className="product-shot reveal-from-bottom" data-reveal-delay={100 * i}>
                <img src={s.src} alt={s.alt} loading="lazy" />
              </figure>
            ))}
            <div className="product-reviews">
              {p.reviews.map(r => (
                <blockquote key={r.author} className="product-review reveal-from-bottom" data-reveal-delay="200">
                  <Stars score={r.stars} />
                  <p className="m-0 mt-8 text-sm">{r.text}</p>
                  <footer className="text-xxs">{r.author} · {r.source}</footer>
                </blockquote>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ProductGoddessMecha;
